import React, { useState, useRef, useContext, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  Paper,
  Divider,
  Checkbox,
  CircularProgress,
  IconButton,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import { MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import CheckIcon from "@mui/icons-material/Check";
import axiosInstance from "./axios";
import logo from "../images/google.png";
import { Autocomplete } from "@react-google-maps/api";
import { useJsApiLoader } from "@react-google-maps/api";
import { getGeocode } from "use-places-autocomplete";
import { isAuthenticated } from "../globals/helper";
import AddIcon from "@mui/icons-material/Add";
import { ChevronLeft } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Header = styled(Box)({
  borderWidth: "1px",
  borderBottom: "1px solid rgb(184, 183, 183)",
});

const CustomCheckbox = styled(Checkbox)({
  width: 18,
  height: 18,
  padding: 0,
  "& .MuiSvgIcon-root": {
    fontSize: 0,
  },
  "& .custom-icon": {
    width: 18,
    height: 18,
    borderRadius: "4px",
    border: "2px solid #5C84FF",
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "&.Mui-checked .custom-icon": {
    backgroundColor: "#5C84FF",
    border: "2px solid #5C84FF",
  },
  "&.Mui-checked .custom-icon svg": {
    fontSize: 14,
    color: "white",
  },
});

const FormSection = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
}));

const OrderSummary = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  position: "sticky",
  top: theme.spacing(3),
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Montserrat",
  fontSize: "20px",
  fontWeight: "600",
  marginBottom: theme.spacing(2),
  color: "gary",
}));

const SummaryTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Montserrat",
  fontSize: "20px",
  fontWeight: "600",
  marginBottom: theme.spacing(2),
  color: "gray",
}));

const SummaryItem = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: theme.spacing(1),
  padding: theme.spacing(1, 0),
  borderBottom: "1px solid #eee",
}));

const SummaryTotal = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: theme.spacing(2),
  paddingTop: theme.spacing(2),
  // borderTop: "2px solid #eee",
  fontWeight: "bold",
}));

function ManualOrderCreation() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    email: "",
    businessEmail: "",
    phone: "",
    business: "",
    country: "",
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    products: "",
    transactionId: "",
    shippingCost: "0.00",
    paymentoption: "", // <-- added here
  });

  const [shippingFormData, setShippingFormData] = useState({
    country: "",
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
  });

  const [useBillingAsShipping, setUseBillingAsShipping] = useState(true);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [shippingStates, setShippingStates] = useState([]);
  const [products, setProducts] = useState([]);
  const [rates, setRates] = useState([]);
  const [shippingCostFetched, setShippingCostFetched] = useState(false);
  const [prevFormData, setPrevFormData] = useState(null);
  const [prevShippingFormData, setPrevShippingFormData] = useState(null);
  const [error, setError] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [orderSuccess, setOrderSuccess] = useState(false);
  const autoCompleteRef = useRef(null);
  const [placeId, setPlaceId] = useState(null);
  const [addressError, setAddressError] = useState("");
  const addressInputRef = useRef(null);
  const [userId, setUserId] = useState("");
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const businessSectionRef = useRef(null);
  const [business, setBusiness] = useState("");
  const [orderId, setOrderId] = useState(null);
  const [paymentOption, setPaymentOption] = useState("");
  const navigate = useNavigate();

  const [fieldErrors, setFieldErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    businessEmail: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
    products: "",
    transactionId: "",
    paymentoption: "",
  });

  // Add loading state
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Fetch countries and set default US country

  const onLoad = (autocomplete) => {
    autoCompleteRef.current = autocomplete;
  };

  const onPlaceChanged = async () => {
    if (autoCompleteRef.current !== null) {
      const place = autoCompleteRef.current.getPlace();

      if (place) {
        // ✅ Get the correct place_id from place object
        if (place.place_id) {
          setPlaceId(place.place_id);
        } else {
          console.warn("Place ID not found in place object.");
        }

        // ✅ Set address if available
        if (place.formatted_address) {
          setSelectedAddress(place.formatted_address);
          setAddressError(""); // Clear any previous error
        }

        try {
          // Fetch geocode details if needed
          const results = await getGeocode({
            address: place.formatted_address,
          });
        } catch (error) {
          console.error("Error fetching geocode:", error);
        }
      }
    }
  };

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyBK2LtRcuFRSz4ZYZwaz8XAaj3RMTOKfh8",
    libraries: ["places"],
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    if (isAuthenticated()) {
      setUserLoggedIn(true);
      fetchUserDetails(); // Fetch user details
    }
  }, []);
  const fetchUserDetails = async () => {
    try {
      const response = await axiosInstance.post(
        "user.php?method=get_user_details"
      );
      if (response.data.user) {
        setUserId(response.data.user.id || ""); // Store user ID
        setFormData((prev) => ({
          ...prev,
          email: response.data.user.email || "",
        }));
      } else {
        console.warn("No user details received from API.");
      }
    } catch (error) {
      console.error("Error getting user details", error);
    }
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axiosInstance.post(
          "payments.php?method=countries"
        );
        if (response.data.countries) {
          setCountries(response.data.countries);
          // Set "United States" as the default country
          const defaultCountry = response.data.countries.find(
            (c) => c.name === "United States"
          );
          if (defaultCountry) {
            setFormData((prev) => ({
              ...prev,
              country: defaultCountry.id,
            }));
            fetchStates(defaultCountry.id);
          }
        }
      } catch (err) {
        console.error("Error fetching countries:", err);
        setError("Failed to fetch countries");
      }
    };

    fetchCountries();
  }, []);

  // Fetch products and set default product
  useEffect(() => {
    const fetchPlates = async () => {
      try {
        const response = await axiosInstance.post(
          "payments.php?method=products"
        );
        if (response.data.places && response.data.places.length > 0) {
          setProducts(response.data.places);
          // Set first product as default
          setFormData((prev) => ({
            ...prev,
            products: response.data.places[0].id,
          }));
        }
      } catch (err) {
        console.error("Error fetching plates:", err);
        setError("Failed to fetch products");
      }
    };
    fetchPlates();
  }, []);
  // Fetch states when country changes
  useEffect(() => {
    if (formData.country) {
      const selectedCountry = countries.find((c) => c.id === formData.country);
      if (selectedCountry) {
        fetchStates(selectedCountry.id);
      }
    }
  }, [formData.country]);

  // Fetch shipping states when shipping country changes
  useEffect(() => {
    if (shippingFormData.country) {
      const selectedCountry = countries.find(
        (c) => c.id === shippingFormData.country
      );
      if (selectedCountry) {
        fetchShippingStates(selectedCountry.id);
      }
    }
  }, [shippingFormData.country]);

  const requiredFields = ["country", "address", "city", "state", "zipCode"];
  const areAllFieldsFilled = () => {
    return requiredFields.every(
      (field) => formData[field] && formData[field].trim() !== ""
    );
  };

  // Call shipping cost API when billing address details change
  useEffect(() => {
    // Only proceed if all required fields are filled
    if (!areAllFieldsFilled()) return;
    if (!shippingCostFetched) {
      shippingCost();
      return;
    }

    // If it's not the first time, check for field changes
    if (prevFormData) {
      const hasChanged = requiredFields.some(
        (field) => prevFormData[field] !== formData[field]
      );

      // Also check if product has changed
      const productChanged = prevFormData.products !== formData.products;

      if (hasChanged) {
        shippingCost();
      }
    }

    // Update previous form data for next change detection
    setPrevFormData({ ...formData });
  }, [formData]);

  // Update shipping cost in formData when rates change
  useEffect(() => {
    if (rates.length > 0 && rates[0]?.total_charge) {
      setFormData((prev) => ({
        ...prev,
        shippingCost: rates[0].total_charge.toFixed(2),
      }));
    }
  }, [rates]);

  // Call shipping cost API when shipping address details change
  useEffect(() => {
    // Only proceed if not using billing as shipping
    if (useBillingAsShipping) return;

    // Check if all required shipping fields are filled
    const shippingRequiredFields = [
      "country",
      "address",
      "city",
      "state",
      "zipCode",
    ];
    const areAllShippingFieldsFilled = shippingRequiredFields.every(
      (field) =>
        shippingFormData[field] && shippingFormData[field].trim() !== ""
    );

    if (!areAllShippingFieldsFilled) return;

    // Check if product is selected
    if (!formData.products) return;

    // If it's the first time all fields are filled, call the API
    if (!shippingCostFetched) {
      shippingCost();
      return;
    }

    // If it's not the first time, check for field changes
    if (prevShippingFormData) {
      const hasChanged = shippingRequiredFields.some(
        (field) => prevShippingFormData[field] !== shippingFormData[field]
      );

      // Also check if product has changed
      const productChanged =
        prevFormData && prevFormData.products !== formData.products;

      if (hasChanged || productChanged) {
        shippingCost();
      }
    }

    // Update previous shipping form data for next change detection
    setPrevShippingFormData({ ...shippingFormData });
  }, [shippingFormData, useBillingAsShipping, formData.products]);

  const shippingCost = async () => {
    try {
      // Find the country shortname using the country ID
      const selectedCountry = countries.find((c) => c.id === formData.country);
      const countryShortname = selectedCountry ? selectedCountry.shortname : "";

      const response = await axiosInstance.post(
        "payments.php?method=shipping_cost",
        {
          destination_address: {
            city: formData.city,
            state: formData.state,
            address: formData.address,
            country: countryShortname, // Use the shortname here
            pincode: formData.zipCode,
            product_id: formData.products,
          },
        }
      );

      if (!response.data.rates || response.data.rates.length === 0) {
        setRates([]); // Ensure UI handles empty rates
        return;
      }

      // Sort rates by cost_rank
      const sortedRates = [...response.data.rates].sort(
        (a, b) => a.cost_rank - b.cost_rank
      );

      setShippingCostFetched(true); // Mark that we've fetched shipping costs
      setRates(sortedRates);
    } catch (err) {
      console.error("❌ Error fetching shipping cost:", err);
      setError("Failed to fetch shipping costs. Please try again.");
    }
  };

  const fetchStates = async (countryId) => {
    try {
      const response = await axiosInstance.post("payments.php?method=states", {
        country_id: countryId,
      });

      if (response.data.states) {
        setStates(response.data.states);
      } else {
        setStates([]);
      }
    } catch (err) {
      console.error("Error fetching states:", err);
      setStates([]);
    }
  };

  const fetchShippingStates = async (countryId) => {
    try {
      const response = await axiosInstance.post("payments.php?method=states", {
        country_id: countryId,
      });
      if (response.data.states) {
        setShippingStates(response.data.states);
      } else {
        setShippingStates([]);
      }
    } catch (err) {
      console.error("Error fetching shipping states:", err);
      setShippingStates([]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error when user starts typing
    if (fieldErrors[name]) {
      setFieldErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleShippingChange = (e) => {
    const { name, value } = e.target;
    setShippingFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBillingShippingCheckbox = (event) => {
    setUseBillingAsShipping(event.target.checked);
    if (event.target.checked) {
      // When checked, copy billing address to shipping address
      setShippingFormData({
        country: formData.country,
        firstName: formData.firstName,
        lastName: formData.lastName,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        zipCode: formData.zipCode,
      });
    } else {
      setShippingFormData({
        country: "",
        firstName: "",
        lastName: "",
        address: "",
        city: "",
        state: "",
        zipCode: "",
      });
    }
  };

  const validateForm = () => {
    // Check firstName first
    if (!formData.firstName || formData.firstName.trim() === "") {
      setFieldErrors((prev) => ({
        ...prev,
        firstName: "First Name is required",
      }));
      // Scroll to the first name input field
      const firstNameInput = document.querySelector('input[name="firstName"]');
      if (firstNameInput) {
        firstNameInput.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        firstNameInput.focus();
      }
      throw new Error("First Name is required");
    }
    setFieldErrors((prev) => ({ ...prev, firstName: "" }));

    // Check lastName next
    if (!formData.lastName || formData.lastName.trim() === "") {
      setFieldErrors((prev) => ({
        ...prev,
        lastName: "Last Name is required",
      }));
      throw new Error("Last Name is required");
    }
    setFieldErrors((prev) => ({ ...prev, lastName: "" }));

    // Check email
    if (!formData.email || formData.email.trim() === "") {
      setFieldErrors((prev) => ({ ...prev, email: "Email is required" }));
      throw new Error("Email is required");
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setFieldErrors((prev) => ({
        ...prev,
        email: "Please enter a valid email address",
      }));
      throw new Error("Please enter a valid email address");
    }
    setFieldErrors((prev) => ({ ...prev, email: "" }));

    if (
      formData.businessEmail &&
      formData.businessEmail.trim() !== "" &&
      !emailRegex.test(formData.businessEmail)
    ) {
      setFieldErrors((prev) => ({
        ...prev,
        businessEmail: "Please enter a valid business email address",
      }));
      throw new Error("Please enter a valid business email address");
    }
    setFieldErrors((prev) => ({ ...prev, businessEmail: "" }));

    // Check phone
    if (!formData.phone || formData.phone.trim() === "") {
      setFieldErrors((prev) => ({
        ...prev,
        phone: "Phone Number is required",
      }));
      // Scroll to the phone input field
      const phoneInput = document.querySelector(".phone-input");
      if (phoneInput) {
        phoneInput.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        phoneInput.focus();
      }
      throw new Error("Phone Number is required");
    }
    const phoneRegex = /^\+?[\d\s-]{10,}$/;
    if (!phoneRegex.test(formData.phone)) {
      setFieldErrors((prev) => ({
        ...prev,
        phone: "Please enter a valid phone number",
      }));
      throw new Error("Please enter a valid phone number");
    }
    setFieldErrors((prev) => ({ ...prev, phone: "" }));

    // Check transaction ID
    if (!formData.transactionId || formData.transactionId.trim() === "") {
      setFieldErrors((prev) => ({
        ...prev,
        transactionId: "Transaction ID is required",
      }));
      // Scroll to the transaction ID input field
      const transactionIdInput = document.querySelector(
        'input[name="transactionId"]'
      );
      if (transactionIdInput) {
        transactionIdInput.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        transactionIdInput.focus();
      }
      throw new Error("Transaction ID is required");
    }
    setFieldErrors((prev) => ({ ...prev, transactionId: "" }));

    // Check address
    if (!formData.address || formData.address.trim() === "") {
      setFieldErrors((prev) => ({ ...prev, address: "Address is required" }));
      throw new Error("Address is required");
    }
    setFieldErrors((prev) => ({ ...prev, address: "" }));

    // Check city
    if (!formData.city || formData.city.trim() === "") {
      setFieldErrors((prev) => ({ ...prev, city: "City is required" }));
      throw new Error("City is required");
    }
    setFieldErrors((prev) => ({ ...prev, city: "" }));

    // Check state
    if (!formData.state || formData.state.trim() === "") {
      setFieldErrors((prev) => ({ ...prev, state: "State is required" }));
      throw new Error("State is required");
    }
    setFieldErrors((prev) => ({ ...prev, state: "" }));

    // Check zipCode
    if (!formData.zipCode || formData.zipCode.trim() === "") {
      setFieldErrors((prev) => ({ ...prev, zipCode: "Zip Code is required" }));
      throw new Error("Zip Code is required");
    }
    const zipRegex = /^(?:\d{4,8}|[A-Za-z0-9\s-]+)$/;
    if (!zipRegex.test(formData.zipCode)) {
      setFieldErrors((prev) => ({
        ...prev,
        zipCode: "Please enter a valid ZIP code",
      }));
      throw new Error("Please enter a valid ZIP code");
    }
    setFieldErrors((prev) => ({ ...prev, zipCode: "" }));

    // Check country
    if (!formData.country || formData.country.trim() === "") {
      setFieldErrors((prev) => ({ ...prev, country: "Country is required" }));
      throw new Error("Country is required");
    }
    setFieldErrors((prev) => ({ ...prev, country: "" }));

    // Check products
    if (!formData.products || formData.products.trim() === "") {
      setFieldErrors((prev) => ({ ...prev, products: "Products is required" }));
      throw new Error("Products is required");
    }
    setFieldErrors((prev) => ({ ...prev, products: "" }));

    // Validate shipping address if not using billing address
    if (!useBillingAsShipping) {
      // Check shipping firstName
      if (
        !shippingFormData.firstName ||
        shippingFormData.firstName.trim() === ""
      ) {
        setFieldErrors((prev) => ({
          ...prev,
          shippingFirstName: "Shipping First Name is required",
        }));
        throw new Error("Shipping First Name is required");
      }
      setFieldErrors((prev) => ({ ...prev, shippingFirstName: "" }));

      // Check shipping lastName
      if (
        !shippingFormData.lastName ||
        shippingFormData.lastName.trim() === ""
      ) {
        setFieldErrors((prev) => ({
          ...prev,
          shippingLastName: "Shipping Last Name is required",
        }));
        throw new Error("Shipping Last Name is required");
      }
      setFieldErrors((prev) => ({ ...prev, shippingLastName: "" }));

      // Check shipping address
      if (!shippingFormData.address || shippingFormData.address.trim() === "") {
        setFieldErrors((prev) => ({
          ...prev,
          shippingAddress: "Shipping Address is required",
        }));
        throw new Error("Shipping Address is required");
      }
      setFieldErrors((prev) => ({ ...prev, shippingAddress: "" }));

      // Check shipping city
      if (!shippingFormData.city || shippingFormData.city.trim() === "") {
        setFieldErrors((prev) => ({
          ...prev,
          shippingCity: "Shipping City is required",
        }));
        throw new Error("Shipping City is required");
      }
      setFieldErrors((prev) => ({ ...prev, shippingCity: "" }));

      // Check shipping state
      if (!shippingFormData.state || shippingFormData.state.trim() === "") {
        setFieldErrors((prev) => ({
          ...prev,
          shippingState: "Shipping State is required",
        }));
        throw new Error("Shipping State is required");
      }
      setFieldErrors((prev) => ({ ...prev, shippingState: "" }));

      // Check shipping zipCode
      if (!shippingFormData.zipCode || shippingFormData.zipCode.trim() === "") {
        setFieldErrors((prev) => ({
          ...prev,
          shippingZipCode: "Shipping Zip Code is required",
        }));
        throw new Error("Shipping Zip Code is required");
      }
      if (!zipRegex.test(shippingFormData.zipCode)) {
        setFieldErrors((prev) => ({
          ...prev,
          shippingZipCode: "Please enter a valid shipping ZIP code",
        }));
        throw new Error("Please enter a valid shipping ZIP code");
      }
      setFieldErrors((prev) => ({ ...prev, shippingZipCode: "" }));

      // Check shipping country
      if (!shippingFormData.country || shippingFormData.country.trim() === "") {
        setFieldErrors((prev) => ({
          ...prev,
          shippingCountry: "Shipping Country is required",
        }));
        throw new Error("Shipping Country is required");
      }
      setFieldErrors((prev) => ({ ...prev, shippingCountry: "" }));
    }
  };

  const TotalPrice =
    rates?.length > 0 && rates[0]?.total_charge
      ? parseFloat(
          (
            Number(
              products.find((p) => p.id === formData.products)?.price || 0
            ) + Number(rates[0]?.total_charge)
          ).toFixed(2)
        )
      : parseFloat(
          Number(
            products.find((p) => p.id === formData.products)?.price || 0
          ).toFixed(2)
        );

  // Function to reset all form fields
  const resetForm = () => {
    setFormData({
      email: "",
      businessEmail: "",
      phone: "",
      business: "",
      firstName: "",
      lastName: "",
      address: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
      products: "",
      transactionId: "",
      paymentoption:"",
      shippingCost: "0.00",
    });

    setShippingFormData({
      country: "",
      firstName: "",
      lastName: "",
      address: "",
      city: "",
      state: "",
      zipCode: "",
    });

    setSelectedAddress("");
    setPlaceId(null);
    setAddressError("");
    setBusiness(""); // Reset business name

    // Reset shipping cost related states
    setRates([]);
    setShippingCostFetched(false);
    setPrevFormData(null);
    setPrevShippingFormData(null);

    // Reset the checkbox to default state
    setUseBillingAsShipping(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsSubmitting(true); // Start loading
      if (!selectedAddress) {
        setAddressError(
          "Please enter your location before purchasing the product"
        );
        // Scroll to the address input field
        if (addressInputRef.current) {
          addressInputRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          addressInputRef.current.focus();
        }
        return;
      }
      validateForm();

      // Find country shortnames
      const billingCountry = countries.find((c) => c.id === formData.country);
      const shippingCountry = useBillingAsShipping
        ? billingCountry
        : countries.find((c) => c.id === shippingFormData.country);
      const customerName = [formData.firstName, formData.lastName]
        .map((value) => value.trim())
        .filter(Boolean)
        .join(" ");
      const shippingName = useBillingAsShipping
        ? customerName
        : [shippingFormData.firstName, shippingFormData.lastName]
            .map((value) => value.trim())
            .filter(Boolean)
            .join(" ");

      const orderPayload = {
        user_id: userId || "",
        name: customerName,
        email: formData.email.trim(),
        business_email: formData.businessEmail.trim(),
        phone: formData.phone,
        product_id: formData.products,
        place_id: placeId,
        transaction_id: formData.transactionId || "custom",
        payment_option:formData.paymentoption === "Paid" ? 0: formData.paymentoption === "Free" ? 1 : "",
        amount: parseFloat(TotalPrice),
        shipping_id: rates[0]?.courier_service?.id,
        shipping_name: `${rates[0]?.courier_service?.name || ""} ${
          rates[0]?.courier_service?.umbrella_name || ""
        }`,
        shipping_description: rates[0]?.full_description,
        shipping_price: formData.shippingCost || rates[0]?.total_charge,
        ship_details: {
          city: formData.city,
          state: formData.state,
          address: formData.address,
          country: billingCountry?.shortname || "",
          pincode: formData.zipCode,
          name: customerName,
        },
        bill_details: useBillingAsShipping
          ? {
              city: formData.city,
              state: formData.state,
              address: formData.address,
              country: billingCountry?.shortname || "",
              pincode: formData.zipCode,
              name: customerName,
            }
          : {
              city: shippingFormData.city,
              state: shippingFormData.state,
              address: shippingFormData.address,
              country: shippingCountry?.shortname || "",
              pincode: shippingFormData.zipCode,
              name: shippingName,
            },
      };
      // console.log("Order Payload:", orderPayload);
      const orderResponse = await axiosInstance.post(
        "payments.php?method=create_order",
        orderPayload
      );

      if (orderResponse.data.status !== "success") {
        throw new Error("Order creation failed");
      }

      // Capture the order ID from the response
      setOrderId(orderResponse.data.orderid);

      // Set order success to true when order is created successfully
      setOrderSuccess(true);
      setError(null);

      // Reset form after successful order creation
      resetForm();
    } catch (err) {
      setError(err.message);
      setOrderSuccess(false);
    } finally {
      setIsSubmitting(false); // End loading regardless of success or failure
    }
  };

  const handleNavigationBack = () => {
    navigate("/dashboard/customerorders");
  };

  if (loadError)
    return <Typography color="error">Error loading maps</Typography>;
  if (!isLoaded) return <CircularProgress />;
  return (
    <Box sx={{ minHeight: "100vh" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          // mb: 3,
          px: { xs: "10px", sm: "5px" },
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontFamily: "Roboto",
            fontSize: { xs: "22px", sm: "28px" },
          }}
        >
          {t("Manual Order Creation")}
        </Typography>
        <IconButton
          onClick={handleNavigationBack}
          sx={{ color: "primary.main" }}
        >
          <ChevronLeft sx={{ color: "primary.main" }} />
          <Typography sx={{ fontWeight: "bold", color: "primary.main" }}>
            {t("Back")}
          </Typography>
        </IconButton>
      </Box>
      <Box
        sx={{ p: { xs: "12px", sm: "40px" }, maxWidth: "1200px", mx: "auto" }}
      >
        {/* <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "24px",
            fontWeight: "600",
            mb: 3,
            color: "gray",
          }}
        >
          Manual Order Creation
        </Typography> */}
        <Box
          sx={{
            borderRadius: "10px",
            backgroundColor: "#d7d7d7",
            pt: { xs: "15px", sm: "6px" },
            pb: { xs: "20px", sm: "50px" },
            px: { xs: "10px", sm: "10px" },
            mt: { xs: "16px", sm: "20px" },
            marginBottom: "10px",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Montserrat",
              fontWeight: "bold",
              fontSize: "16px",
              letterSpacing: "1px",
              lineHeight: { xs: "18px", sm: "34px" },
              marginLeft: { xs: "10px", sm: "10px" },
              py: { xs: "", sm: "8px" },
            }}
            ref={businessSectionRef}
          >
            {t("Search for your business to get set up")}{" "}
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              py: { xs: "15px", sm: "0px" },
              marginLeft: { xs: "10px", sm: "10px" },
            }}
          >
            <Box component="img" src={logo} />
            <Box sx={{ width: "80%" }}>
              <Autocomplete
                onLoad={onLoad}
                onPlaceChanged={onPlaceChanged}
                options={{ types: [] }}
              >
                <TextField
                  id="products-section"
                  inputRef={addressInputRef}
                  fullWidth
                  variant="outlined"
                  // placeholder="Search for an address"
                  label={t("searchAddress")}
                  error={!!addressError}
                  helperText={addressError}
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "10px",
                    fontWeight: 500,
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderRadius: "10px",
                      },
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "10px",
                    },
                    "& .MuiInputLabel-root": {
                      fontWeight: "bold",
                      top: "-6px",
                      fontsize: "14px",
                      fontFamily: "Goldplay",
                    },
                  }}
                />
              </Autocomplete>
            </Box>
          </Box>
          <Box
            sx={{
              paddingLeft: { xs: "8px", sm: "42px" },
              pt: { xs: "", sm: "6px" },
            }}
          >
            <Box component="ul" sx={{ margin: 0 }}>
              <Box component="li" sx={{ "::marker": { fontSize: "10px" } }}>
                <Typography
                  sx={{
                    fontFamily: "Montserrat",
                    fontSize: "11px",
                    fontWeight: "500",
                    lineHeight: "15px",
                    letterSpacing: "1px",
                  }}
                >
                  {t(
                    "Can't find your business? No worries.Enter your business name,"
                  )}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Montserrat",
                    fontSize: "11px",
                    fontWeight: "500",
                    lineHeight: "15px",
                    letterSpacing: "1px",
                  }}
                >
                  {t("city and postal code.")}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <form onSubmit={handleSubmit}>
              <FormSection>
                <SectionTitle>{t("Business Information")}</SectionTitle>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: "500",
                        mb: 1,
                      }}
                    >
                      {t("Select Products")}
                    </Typography>
                    <TextField
                      select
                      name="products"
                      value={formData.products}
                      onChange={handleChange}
                      fullWidth
                      variant="outlined"
                      error={!!fieldErrors.products}
                      helperText={fieldErrors.products}
                      SelectProps={{
                        displayEmpty: true,
                        IconComponent: KeyboardArrowDownIcon,
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 40,
                        },
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select Products
                      </MenuItem>
                      {products.map((product) => (
                        <MenuItem key={product.id} value={product.id}>
                          {product.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      sx={{
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: "500",
                        mb: 1,
                      }}
                    >
                      {t("Business Email")}
                    </Typography>
                    <TextField
                      name="businessEmail"
                      value={formData.businessEmail}
                      onChange={handleChange}
                      placeholder={t("Business Email")}
                      type="email"
                      variant="outlined"
                      fullWidth
                      error={!!fieldErrors.businessEmail}
                      helperText={fieldErrors.businessEmail}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 40,
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      sx={{
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: "500",
                        mb: 1,
                      }}
                    >
                      {t("Customer Email")}
                    </Typography>
                    <TextField
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder={t("Customer Email")}
                      type="email"
                      variant="outlined"
                      fullWidth
                      error={!!fieldErrors.email}
                      helperText={fieldErrors.email}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 40,
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      sx={{
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: "500",
                        mb: 1,
                      }}
                    >
                      {t("Phone")}
                    </Typography>
                    <PhoneInput
                      country={"us"}
                      value={formData.phone}
                      onChange={(phone) =>
                        handleChange({
                          target: { name: "phone", value: phone },
                        })
                      }
                      inputStyle={{
                        width: "100%",
                        height: "40px",
                        borderRadius: "4px",
                        border: fieldErrors.phone
                          ? "1px solid #d32f2f"
                          : "1px solid rgba(0, 0, 0, 0.23)",
                        paddingLeft: "48px",
                        fontSize: "16px",
                      }}
                      containerStyle={{ width: "100%" }}
                      className="phone-input"
                    />
                    {fieldErrors.phone && (
                      <Typography
                        sx={{
                          color: "#d32f2f",
                          fontSize: "0.75rem",
                          marginTop: "3px",
                          marginLeft: "14px",
                          fontFamily: "Montserrat",
                        }}
                      >
                        {fieldErrors.phone}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </FormSection>

              <FormSection>
                <SectionTitle>{t("Delivery Address")}</SectionTitle>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      placeholder={t("firstName")}
                      variant="outlined"
                      fullWidth
                      error={!!fieldErrors.firstName}
                      helperText={fieldErrors.firstName}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 40,
                        },
                        "& input:-webkit-autofill": {
                          WebkitBoxShadow:
                            "0 0 0 1000px white inset !important", // Removes autofill background
                          backgroundColor: "transparent !important",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      placeholder={t("lastName")}
                      variant="outlined"
                      fullWidth
                      error={!!fieldErrors.lastName}
                      helperText={fieldErrors.lastName}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 40,
                        },
                        "& input:-webkit-autofill": {
                          WebkitBoxShadow:
                            "0 0 0 1000px white inset !important", // Removes autofill background
                          backgroundColor: "transparent !important",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      placeholder={t("address")}
                      variant="outlined"
                      fullWidth
                      error={!!fieldErrors.address}
                      helperText={fieldErrors.address}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 40,
                        },
                        "& input:-webkit-autofill": {
                          WebkitBoxShadow:
                            "0 0 0 1000px white inset !important", // Removes autofill background
                          backgroundColor: "transparent !important",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      select
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      fullWidth
                      variant="outlined"
                      error={!!fieldErrors.country}
                      helperText={fieldErrors.country}
                      SelectProps={{
                        displayEmpty: true,
                        IconComponent: KeyboardArrowDownIcon,
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 40,
                        },
                        "& input:-webkit-autofill": {
                          WebkitBoxShadow:
                            "0 0 0 1000px white inset !important", // Removes autofill background
                          backgroundColor: "transparent !important",
                        },
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select Country
                      </MenuItem>
                      {countries.map((country) => (
                        <MenuItem key={country.id} value={country.id}>
                          {country.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      placeholder={t("city")}
                      variant="outlined"
                      fullWidth
                      error={!!fieldErrors.city}
                      helperText={fieldErrors.city}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 40,
                        },
                        "& input:-webkit-autofill": {
                          WebkitBoxShadow:
                            "0 0 0 1000px white inset !important", // Removes autofill background
                          backgroundColor: "transparent !important",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      select
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      fullWidth
                      variant="outlined"
                      error={!!fieldErrors.state}
                      helperText={fieldErrors.state}
                      SelectProps={{
                        displayEmpty: true,
                        IconComponent: KeyboardArrowDownIcon,
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 40,
                        },
                        "& input:-webkit-autofill": {
                          WebkitBoxShadow:
                            "0 0 0 1000px white inset !important", // Removes autofill background
                          backgroundColor: "transparent !important",
                        },
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select State
                      </MenuItem>
                      {states.map((state) => (
                        <MenuItem key={state.id} value={state.id}>
                          {state.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      name="zipCode"
                      value={formData.zipCode}
                      onChange={handleChange}
                      placeholder={t("zipCode")}
                      variant="outlined"
                      fullWidth
                      error={!!fieldErrors.zipCode}
                      helperText={fieldErrors.zipCode}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 40,
                        },
                        "& input:-webkit-autofill": {
                          WebkitBoxShadow:
                            "0 0 0 1000px white inset !important", // Removes autofill background
                          backgroundColor: "transparent !important",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </FormSection>
              <FormSection>
                <SectionTitle>{t("Payment Details")}</SectionTitle>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      sx={{
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: "500",
                        mb: 1,
                      }}
                    >
                      {t("Transaction ID")}
                    </Typography>
                    <TextField
                      name="transactionId"
                      value={formData.transactionId || ""}
                      onChange={handleChange}
                      placeholder={t("enterTransactionId")}
                      variant="outlined"
                      fullWidth
                      error={!!fieldErrors.transactionId}
                      helperText={fieldErrors.transactionId}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 40,
                        },
                        "& input:-webkit-autofill": {
                          WebkitBoxShadow:
                            "0 0 0 1000px white inset !important", // Removes autofill background
                          backgroundColor: "transparent !important",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      sx={{
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: "500",
                        mb: 1,
                      }}
                    >
                      {t("Shipping Cost")}
                    </Typography>
                    <TextField
                      name="shippingCost"
                      value={
                        formData.shippingCost !== "0.00"
                          ? formData.shippingCost
                          : rates[0]?.total_charge
                          ? rates[0].total_charge.toFixed(2)
                          : "0.00"
                      }
                      onChange={(e) => {
                        const newValue = e.target.value;
                        // Only update if it's a valid number or empty
                        if (newValue === "" || !isNaN(parseFloat(newValue))) {
                          handleChange(e);
                          // Update the rates array to reflect the new shipping cost
                          if (rates.length > 0) {
                            const updatedRates = [...rates];
                            updatedRates[0] = {
                              ...updatedRates[0],
                              total_charge: parseFloat(newValue) || 0,
                            };
                            setRates(updatedRates);
                          }
                        }
                      }}
                      placeholder="0.00"
                      variant="outlined"
                      fullWidth
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 40,
                        },
                        "& input:-webkit-autofill": {
                          WebkitBoxShadow:
                            "0 0 0 1000px white inset !important", // Removes autofill background
                          backgroundColor: "transparent !important",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Typography
                      sx={{
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: "500",
                        mb: 1,
                      }}
                    >
                      {t("Payment Options")}
                    </Typography>
                    <Select
                      name="paymentoption"
                      value={formData.paymentoption}
                      onChange={handleChange}
                      displayEmpty
                      fullWidth
                      sx={{
                        height: 40,
                        backgroundColor: "#fff",
                        "& .MuiSelect-select": {
                          paddingY: "8px",
                        },
                      }}
                    >
                      <MenuItem value="" disabled>
                        {t("Select Payment Option")}
                      </MenuItem>
                      <MenuItem value="Paid">{t("Paid")}</MenuItem>
                      <MenuItem value="Free">{t("Free")}</MenuItem>
                    </Select>
                  </Grid>
                </Grid>
              </FormSection>
              <FormSection>
                <Box
                  sx={{
                    paddingLeft: "10px",
                    display: "flex",
                    gap: "6px",
                    marginBottom: "10px",
                  }}
                >
                  <CustomCheckbox
                    checked={useBillingAsShipping}
                    onChange={handleBillingShippingCheckbox}
                    icon={<span className="custom-icon" />}
                    checkedIcon={
                      <span className="custom-icon">
                        <CheckIcon />
                      </span>
                    }
                  />
                  <Typography
                    fontSize={{ xs: "12px", sm: "14px" }}
                    fontFamily={"Montserrat"}
                  >
                    {t("Use billing address as Shipping address")}
                  </Typography>
                </Box>

                {!useBillingAsShipping && (
                  <>
                    <Divider sx={{ my: 3 }} />
                    <SectionTitle>{t("Billing Address")}</SectionTitle>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          name="firstName"
                          value={shippingFormData.firstName}
                          onChange={handleShippingChange}
                          placeholder={t("firstName")}
                          variant="outlined"
                          fullWidth
                          error={!!fieldErrors.shippingFirstName}
                          helperText={fieldErrors.shippingFirstName}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: 40,
                            },
                            "& input:-webkit-autofill": {
                              WebkitBoxShadow:
                                "0 0 0 1000px white inset !important", // Removes autofill background
                              backgroundColor: "transparent !important",
                            },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          name="lastName"
                          value={shippingFormData.lastName}
                          onChange={handleShippingChange}
                          placeholder={t("lastName")}
                          variant="outlined"
                          fullWidth
                          error={!!fieldErrors.shippingLastName}
                          helperText={fieldErrors.shippingLastName}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: 40,
                            },
                            "& input:-webkit-autofill": {
                              WebkitBoxShadow:
                                "0 0 0 1000px white inset !important", // Removes autofill background
                              backgroundColor: "transparent !important",
                            },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          name="address"
                          value={shippingFormData.address}
                          onChange={handleShippingChange}
                          placeholder={t("address")}
                          variant="outlined"
                          fullWidth
                          error={!!fieldErrors.shippingAddress}
                          helperText={fieldErrors.shippingAddress}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: 40,
                            },
                            "& input:-webkit-autofill": {
                              WebkitBoxShadow:
                                "0 0 0 1000px white inset !important", // Removes autofill background
                              backgroundColor: "transparent !important",
                            },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          select
                          name="country"
                          value={shippingFormData.country}
                          onChange={handleShippingChange}
                          fullWidth
                          variant="outlined"
                          error={!!fieldErrors.shippingCountry}
                          helperText={fieldErrors.shippingCountry}
                          SelectProps={{
                            displayEmpty: true,
                            IconComponent: KeyboardArrowDownIcon,
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: 40,
                            },
                            "& input:-webkit-autofill": {
                              WebkitBoxShadow:
                                "0 0 0 1000px white inset !important", // Removes autofill background
                              backgroundColor: "transparent !important",
                            },
                          }}
                        >
                          <MenuItem value="" disabled>
                            Select Country
                          </MenuItem>
                          {countries.map((country) => (
                            <MenuItem key={country.id} value={country.id}>
                              {country.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <TextField
                          name="city"
                          value={shippingFormData.city}
                          onChange={handleShippingChange}
                          placeholder={t("city")}
                          variant="outlined"
                          fullWidth
                          error={!!fieldErrors.shippingCity}
                          helperText={fieldErrors.shippingCity}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: 40,
                            },
                            "& input:-webkit-autofill": {
                              WebkitBoxShadow:
                                "0 0 0 1000px white inset !important", // Removes autofill background
                              backgroundColor: "transparent !important",
                            },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <TextField
                          select
                          name="state"
                          value={shippingFormData.state}
                          onChange={handleShippingChange}
                          fullWidth
                          variant="outlined"
                          error={!!fieldErrors.shippingState}
                          helperText={fieldErrors.shippingState}
                          SelectProps={{
                            displayEmpty: true,
                            IconComponent: KeyboardArrowDownIcon,
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: 40,
                            },
                            "& input:-webkit-autofill": {
                              WebkitBoxShadow:
                                "0 0 0 1000px white inset !important", // Removes autofill background
                              backgroundColor: "transparent !important",
                            },
                          }}
                        >
                          <MenuItem value="" disabled>
                            Select State
                          </MenuItem>
                          {shippingStates.map((state) => (
                            <MenuItem key={state.id} value={state.id}>
                              {state.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <TextField
                          name="zipCode"
                          value={shippingFormData.zipCode}
                          onChange={handleShippingChange}
                          placeholder={t("zipCode")}
                          variant="outlined"
                          fullWidth
                          error={!!fieldErrors.shippingZipCode}
                          helperText={fieldErrors.shippingZipCode}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: 40,
                            },
                            "& input:-webkit-autofill": {
                              WebkitBoxShadow:
                                "0 0 0 1000px white inset !important", // Removes autofill background
                              backgroundColor: "transparent !important",
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
              </FormSection>

              {orderSuccess && (
                <Box
                  sx={{
                    mt: 3,
                    mb: 2,
                    p: 2,
                    backgroundColor: "#e6f4ea",
                    borderRadius: "4px",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#1e7e34",
                      fontFamily: "Montserrat",
                      fontWeight: 500,
                    }}
                  >
                    Order with {orderId} creation successful!
                  </Typography>
                </Box>
              )}

              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={isSubmitting}
                sx={{
                  backgroundColor: "#2B56F5",
                  color: "white",
                  height: "48px",
                  mt: 3,
                  "&:hover": {
                    backgroundColor: "#1E3FA3",
                  },
                  "&:disabled": {
                    backgroundColor: "#cccccc",
                  },
                  position: { xs: "fixed", sm: "initial" },
                  bottom: "0px",
                  left: "0px",
                  zIndex: "3",
                }}
              >
                {isSubmitting ? (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CircularProgress size={20} color="inherit" />
                    <Typography
                      sx={{
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        fontWeight: "600",
                        textTransform: "capitalize",
                      }}
                    >
                      {t("Creating Order...")}
                    </Typography>
                  </Box>
                ) : (
                  <Typography
                    sx={{
                      fontFamily: "Montserrat",
                      fontSize: "16px",
                      fontWeight: "600",
                      textTransform: "capitalize",
                    }}
                  >
                    {t("Create Order")}
                  </Typography>
                )}
              </Button>
            </form>
          </Grid>

          <Grid item xs={12} md={4}>
            <OrderSummary sx={{ mb: { xs: "60px", sm: "0px" } }}>
              <SummaryTitle>{t("Order Details")}</SummaryTitle>
              <SummaryItem>
                <Typography>{t("Product Price")}</Typography>
                <Typography>
                  $
                  {products.find((p) => p.id === formData.products)?.price ||
                    "0.00"}
                </Typography>
              </SummaryItem>

              <SummaryItem>
                <Typography>{t("Shipping Cost")}</Typography>
                <Typography>
                  $
                  {rates[0]?.total_charge
                    ? rates[0].total_charge.toFixed(2)
                    : "0.00"}
                </Typography>
              </SummaryItem>

              <SummaryTotal>
                <Typography>{t("Total")}</Typography>
                <Typography>${TotalPrice}</Typography>
              </SummaryTotal>
            </OrderSummary>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default ManualOrderCreation;
